import React, { useCallback, useEffect, useState, ChangeEvent } from 'react';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

import { CheckboxProps } from '../types';

import './checkbox.scss';

export const Checkbox: React.FC<CheckboxProps> = (props: CheckboxProps) => {
  const { title, name, onChange, checked, className, headerPosition, typeButton, ...rest } = props;

  const [checkedState, setCheckedState] = useState(!!checked);
  const checkBoxClassNames = classnames(`app-checkbox ${className ? className : ''}`, {
    'is-desktop': !isMobile,
    'app-checkbox__button': typeButton,
    'is-active': checkedState,
  });

  const checkBoxLabel = classnames('app-checkbox__label', {
    'app-checkbox__label-second app-checkbox__label__start': headerPosition === 'start',
    'app-checkbox__label-second app-checkbox__label__end': headerPosition === 'end',
  });

  useEffect(() => {
    setCheckedState(!!checked);
  }, [setCheckedState, checked]);

  const onChangeHandler = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(event);
    },
    [onChange],
  );

  return (
    <div className={checkBoxClassNames}>
      <label className={checkBoxLabel}>
        <input
          type="checkbox"
          name={name}
          onChange={onChangeHandler}
          checked={checkedState}
          {...rest}
        />
        <span className="app-checkbox__icon"></span>
        {typeButton && <span className="app-checkbox__border"></span>}
        <div className="app-checkbox__text">{title}</div>
      </label>
    </div>
  );
};
